import { productsService } from 'domains/products/products.service';

import { PaymentsService } from './payments.service';

export * from './payments.reducer';

export const paymentsService = new PaymentsService(productsService);
export * as selectors from './payments.selectors';
